const getUploadPresignedUrl = async (url, abortController, token) => {
  abortController.current = new AbortController();
  const options = {
    signal: abortController.current.signal,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(
        `Failed to get pre-signed URL: ${JSON.stringify(errorResponse)} ${response.status}`
      );
    }
    const data = await response.json();
    if (!data.presigned_url) {
      throw new Error(
        `Pre-signed URL missing in response: ${JSON.stringify(data)}`
      );
    }
    return data.presigned_url;
  } catch (error) {
    throw new Error("Error in getting pre-signed URL", { cause: error });
  }
};

export default getUploadPresignedUrl;
